import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { sanitizeRedirectUrl } from "../../api";

import "./styles.css";

function SecureLogin() {
  const navigate = useNavigate();

  const [originState, setOriginState] = useState(() => {
    const storedData =
      localStorage.getItem("originstate");

    return (
      storedData ||
      new URLSearchParams(
        window.location.search
      ).get("state") ||
      ""
    );
  });

  const [originUrl, setOriginUrl] =
    useState("");

  useEffect(() => {
    async function initialize() {
      try {
        const urlParams =
          new URLSearchParams(
            window.location.search
          );

        const redirectUri =
          localStorage.getItem(
            "originurl"
          ) ||
          urlParams.get(
            "redirect_uri"
          );

        const state =
          urlParams.get("state");

        // No redirect URI
        if (!redirectUri) {
          navigate("/login");
          return;
        }

        // Validate redirect URI
        const response =
          await sanitizeRedirectUrl({
            RedirectURI:
              redirectUri
          });

        // API failure
        if (!response) {
          console.error(
            "Redirect validation API failed"
          );

          navigate("/login");

          return;
        }

        const result =
          await response.json();

        // Invalid redirect URI
        if (
          !response.ok ||
          !result ||
          !result.sanitizedUrl
        ) {
          console.error(
            result?.error ||
              "Invalid redirect URI"
          );

          navigate("/login");

          return;
        }

        // Store validated URL only
        setOriginUrl(
          result.sanitizedUrl
        );

        localStorage.setItem(
          "originurl",
          result.sanitizedUrl
        );

        localStorage.setItem(
          "originstate",
          state || ""
        );

        localStorage.setItem(
          "originredirecturi",
          window.location.origin +
            window.location.pathname
        );

        const IsUserLoggedIn =
          localStorage.getItem(
            "IsUserLoggedIn"
          );

        const email =
          localStorage.getItem(
            "email"
          );

        const token =
          localStorage.getItem(
            "ROCP_idToken"
          );

        // Existing auth logic preserved
        if (
          (
            IsUserLoggedIn ===
              "true" ||
            IsUserLoggedIn ===
              "inprogress"
          ) &&
          email &&
          token
        ) {
          const form =
            document.getElementById(
              "secureform_form"
            );

          if (form) {
            form.action =
              result.sanitizedUrl;

            form.submit();
          }

          localStorage.removeItem(
            "originurl"
          );

          localStorage.removeItem(
            "originstate"
          );

          localStorage.removeItem(
            "originredirecturi"
          );
        } else {
          navigate("/login");
        }
      } catch (error) {
        console.error(
          "Secure login failed",
          error
        );

        navigate("/login");
      }
    }

    initialize();
  }, [navigate]);

  return (
    <div>
      <form
        action={originUrl}
        id="secureform_form"
        method="POST"
      >
        <div className="hide-form">
          <input
            id="email"
            name="email"
            type="text"
            value={
              localStorage.getItem(
                "email"
              ) || ""
            }
            readOnly
          />

          <input
            id="state"
            name="state"
            type="text"
            value={originState}
            readOnly
          />
        </div>
      </form>
    </div>
  );
}

export default SecureLogin;